module.exports = __webpack_public_path__ + "img/New2.7735a972.png";